import { render, staticRenderFns } from "./create-or-edit-template-action.vue?vue&type=template&id=082ef73f&"
import script from "./create-or-edit-template-action.ts?vue&type=script&lang=js&"
export * from "./create-or-edit-template-action.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports